import { DataBean } from "../DataBean";

export class ImportEmployeeFactorsByexe extends DataBean {



    public async importEmployeeFactorsByexe(year: any, month: any, media: any, mediaContext: any, dataStore: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importEmployeeFactors_Number_Number_String_String_String_Number", [year, month, media, mediaContext, dataStore, idEmployee]);
    }

}
